import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { OptionConfigurationLockConfigEntity } from '../configs/entity.config';
import { BrandService } from './brand.service';

@Injectable({
  providedIn: 'root',
})
export class OptionConfigurationLockService {
  constructor(private brandService: BrandService) {}

  configurationLockOption(
    mpcUuid: any,
    plc,
    serviceId,
  ): Observable<IEntity<any>> {
    const appBrand = this.brandService.getAppBrandValue();
    const params = {
      optionMpcUuid: mpcUuid,
      plc,
      serviceId,
      appBrand,
    };

    const iEntity = EntityManager.createEntity(
      OptionConfigurationLockConfigEntity,
      params,
    );
    return EntityManager.saveEntity(iEntity);
  }
}
